import { Box, Checkbox } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { setFilterHasWineGlasses } from "../../../store";

function FilterWineGlass() {
  const dispatch = useDispatch();
  const filterValue = useSelector((state) => state.filter.hasWineGlasses);
  const selectedOption = filterValue === null ? false : true;
  return (
    <Box>
      <Checkbox
        label="Provides Glasses"
        checked={selectedOption}
        onChange={(event) => {
          if (event.target.checked) {
            dispatch(setFilterHasWineGlasses(true));
          } else {
            dispatch(setFilterHasWineGlasses(null));
          }
        }}
      />
    </Box>
  );
}

export default FilterWineGlass;
